<template>
  <x-modal
    class="approval-history"
    title="审批历史"
    :visible.sync="visible"
    @close="handleClose"
  >
    <template v-for="(history, index) in historyData.processList">
      <div :key="index" class="approval-history-item">
        <div class="approval-history-item-header">
          <div class="approval-history-item--avatar">
            <x-avatar :personName="history.userName" :avatarUrl="history.avatarUrl"></x-avatar>
            <div class="approval-history-item--pendant">
              <x-svg-icon :name="`process-status-${getNodeStatusIcon(history.processStatus)}`"></x-svg-icon>
            </div>
          </div>
          <div class="approval-history-item--info">
            <span class="approval-history-item--title">{{ `${history.userName}${history.isDuplicateMan ? '等多人' : ''}【${index === 0 ? '发起申请' : history.nodeName }】` }}</span>
            <span class="approval-histroy-item--time">{{ history.executeTime }}</span>
          </div>
        </div>
        <div v-if="history.processStatus !== 'APPROVING'" class="approval-history-item-content">
          <span class="approval-history-item--commit">{{ history.processComment }}</span>
        </div>
      </div>
    </template>
  </x-modal>
</template>

<script>
import XAvatar from '@/components/x-avatar/x-avatar'
import apis from '@/api'

export default {
  components: {
    XAvatar
  },
  props: {
    documentId: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      visible: false,
      callback: null,
      historyData: {}
    }
  },
  watch: {
    documentId: {
      handler(newVal) {
        if (newVal) {
          this.queryHistoryData(newVal)
        }
      },
      immediate: true
    }
  },
  methods: {
    openModal(callback) {
      this.callback = callback
      this.visible = true
    },
    handleClose() {
      this.callback && this.callback()
    },
    getNodeStatusIcon(processStatus) {
      if (processStatus === 'REJECT') {
        return processStatus
      } else if (processStatus === 'APPROVING') {
        return processStatus
      } else if (processStatus === 'RE_START') {
        return 'APPROVING'
      } else {
        return 'APPROVE'
      }
    },
    queryHistoryData(documentId) {
      const request = {
        ...apis.FORM.QUERY_PROCESS_HISTORY,
        params: {
          documentId
        }
      }
      this.$request(request)
        .asyncThen((resp) => {
          this.historyData = resp.data
        }, (error) => {
          console.error(error)
        }).asyncErrorCatch(error => {
          console.error(error)
        })
    }
  }
}
</script>

<style lang="scss">
.approval-history {
  .approval-history-item {
    display: flex;
    flex-direction: column;
    font-size: $--app-base-font-size;
    &:last-child {
      .approval-history-item-content {
        border: 0;
      }
    }
    .approval-history-item-header {
      display: flex;
      align-items: center;
      .approval-history-item--avatar {
        position: relative;
        flex: 0 0 2.286rem;
        margin-right: 0.5rem;
        .x-avatar {
          width: 2rem;
          height: 2rem;
        }
        .approval-history-item--pendant {
          position: absolute;
          right: 0;
          bottom: 0;
          font-size: 0;
          .x-svg-icon .svg-icon {
            width: 0.86rem !important;
            height: 0.86rem !important;
          }
        }
      }
      .approval-history-item--info {
        flex: 1;
        display: flex;
        justify-content: space-between;
        .approval-history-item--title {
          font-weight: $--app-base-font-weight;
        }
        .approval-histroy-item--time {
          color: $--app-notice-font-color;
        }
      }
    }
    .approval-history-item-content {
      min-height: 1.5rem;
      border-left: 1PX solid $--app-split-line-color;
      padding-left: 1.71rem;
      margin-left: 1rem;
      .approval-history-item--commit {
        color: $--app-notice-font-color;
      }
    }
  }
}
</style>
